export default __webpack_public_path__ + "static/media/271.ea6b8f25.jpg";